module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"consignor":"Consignor","despatchParty":"Despatch party","consignee":"Consignee","deliveryParty":"Delivery party"},"no":{"consignor":"Avsender","despatchParty":"Henteadresse","consignee":"Mottaker","deliveryParty":"Leveringsadresse"}}')
  delete Component.options._Ctor
}
